import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-weixin",
  "use": "icon-icon-weixin-usage",
  "viewBox": "0 0 20.2 18.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20.2 18.5\" id=\"icon-icon-weixin\">\r\n<title>资源 1</title>\r\n<g>\r\n\t<circle cx=\"7\" cy=\"8.4\" r=\"1.5\" />\r\n</g>\r\n<g>\r\n\t<circle cx=\"13.3\" cy=\"8.4\" r=\"1.5\" />\r\n</g>\r\n<g>\r\n\t<path d=\"M4.1,18.5l-0.3-3.1c-2.3-1.5-3.8-4-3.8-6.8C0,3.9,4.5,0,10.1,0c5.7,0,10.1,3.7,10.1,8.5c0,4.8-4.4,8.6-10.1,8.6H8.7\r\n\t\tL4.1,18.5z M10.1,2C5.6,2,2,5,2,8.6c0.1,2.2,1.3,4.3,3.3,5.3l0.5,0.3l0.1,1.7l2.7-0.8h1.5c4.5,0,8.1-3,8.1-6.6\r\n\t\tC18.2,4.9,14.6,2,10.1,2z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-weixin.svg
// module id = /2B3
// module chunks = 60